/**
 * Narrow a GraphQL union/interface result to one concrete type, or `undefined` for anything else.
 * This is usefull when you have a specific typename you are interested in from a union set of Entities for example
 */
export const onlyTypename = <
    T extends { __typename?: string },
    K extends NonNullable<T['__typename']>,
>(
    entity: T | null | undefined,
    typename: K,
): Extract<T, { __typename?: K }> | undefined =>
    entity?.__typename === typename
        ? (entity as Extract<T, { __typename?: K }>)
        : undefined
